module.exports = __webpack_public_path__ + "static/img/p1.b10a60d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/p1.jpg
// module id = 143
// module chunks = 382